module.exports = __webpack_public_path__ + "static/media/love-illustration.0ee134f2.svg";